import axios from 'axios';
import store from '../store'

export async function indicadoreseconomicos(){
    try {
        axios.get('https://mindicador.cl/api')
        .then(response =>{
            //console.log(response.data);
            store.state.dolar = response.data.dolar.valor;
            store.state.uf = response.data.uf.valor;
            store.state.utm = response.data.utm.valor;
            store.state.euro = response.data.euro.valor;
            store.state.ipc = response.data.ipc.valor;
            //store.dispatch('llamandoClientes');
        })
    } catch (error) {
        console.log("Error", error);
    }
}


